import { MainMenu } from 'rangeConfig/@types';
import platform from 'rangeConfig/shared/utils/platform';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import withCategoryFilter from 'rangeConfig/shared/widgets/withCategoryFilter';
import * as R from 'ramda';
import { default as White } from '../../ui/Colors/icons/white.js';
import { default as DarkGrey } from '../../ui/Colors/icons/dark_grey.js';
import { default as BrownWalnutEffect } from '../../ui/Colors/icons/brown_walnut_effect.js';

import productListConfig from './productListConfig';

const WhiteFramesSwiper = R.pipe(withCategoryFilter(['frameWhite']));
const DGFramesSwiper = R.pipe(withCategoryFilter(['frameDG']));
const BWEFramesSwiper = R.pipe(withCategoryFilter(['frameBWE']));

const widgets = {
  desktop: [],
  mobile: [
    {
      id: `frame-color-white`,
      component: WhiteFramesSwiper(withProducts(ProductSwiper, productListConfig)),
      title: 'storageone.colorWhite',
      icon: White,
      iconColor: '#FFFFFF'
    },
    {
      id: `frame-color-dark-grey`,
      component: DGFramesSwiper(withProducts(ProductSwiper, productListConfig)),
      title: 'storageone.colorDarkGrey',
      icon: DarkGrey,
      iconColor: '#5D5551'
    },
    {
      id: `frame-color-brown-walnut-effect`,
      component: BWEFramesSwiper(withProducts(ProductSwiper, productListConfig)),
      title: 'storageone.colorBrownWalnutEffect',
      icon: BrownWalnutEffect,
      iconColor: '#7E5942'
    }
  ]
};

const filters = {
  desktop: [],
  mobile: []
};

const mainMenu: MainMenu = {
  menuTitle: 'storageone.productListMediaShelfTitle',
  behaviors: {
    productGroupEntered: [],
    productGroupExited: []
  },
  filters: filters[platform],
  widgets: widgets[platform]
};

export default mainMenu;
